export { FooterPlatforms } from './FooterPlatforms';
